import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '@/shared/store/slices/authSlice';
import { filtersReducer } from '@/shared/store/slices/filtersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filters: filtersReducer,
  },
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
